import { render, staticRenderFns } from "./CreateClaim.vue?vue&type=template&id=b5ef43e4&scoped=true"
import script from "./CreateClaim.vue?vue&type=script&lang=ts"
export * from "./CreateClaim.vue?vue&type=script&lang=ts"
import style0 from "./CreateClaim.vue?vue&type=style&index=0&id=b5ef43e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ef43e4",
  null
  
)

export default component.exports